import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Course", href: "/course" },
  { label: "Support", href: "/support" },
  { label: "Blog", href: "/blog" },
  { label: "Resources", href: "/resources" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const useLightText = isHome && !scrolled;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/50"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-3 hover:opacity-70 transition-opacity duration-300"
          >
            <img
              src="https://storage.readdy-site.link/project_files/1f18a76f-ed3f-4e88-bb38-b62c775c3336/dd8305a0-1fac-4e33-aa4a-430f46df46f4_ChatGPT-Image-Jun-9-2026-03_24_23-PM.png?v=ad55fcfd6c6876a070c9edc39cde37f1"
              alt="Serena's Quiet Recovery Space logo"
              className="w-10 h-10 rounded-full object-cover"
            />
            {isHome ? (
              <h1
                className={`font-heading text-lg md:text-xl font-medium tracking-tight transition-all duration-500 ${
                  useLightText ? "text-background-50" : "text-foreground-950"
                }`}
              >
                Serena&apos;s Quiet Recovery Space
              </h1>
            ) : (
              <span
                className={`font-heading text-lg md:text-xl font-medium tracking-tight transition-all duration-500 ${
                  useLightText ? "text-background-50" : "text-foreground-950"
                }`}
              >
                Serena&apos;s Quiet Recovery Space
              </span>
            )}
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`relative text-sm font-body font-medium tracking-wide transition-all duration-500 hover:opacity-70 pb-1 ${
                  location.pathname === link.href
                    ? useLightText ? "text-background-50" : "text-foreground-950"
                    : useLightText ? "text-background-200" : "text-foreground-700"
                }`}
              >
                {link.label}
                {location.pathname === link.href && (
                  <span className={`absolute bottom-0 left-0 right-0 h-px transition-colors duration-500 ${
                    useLightText ? "bg-background-50" : "bg-foreground-900"
                  }`} />
                )}
              </Link>
            ))}
          </nav>

          <a
            href="https://sraimes43.systeme.io/course"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={`hidden md:inline-block font-body text-sm font-medium px-5 py-2 rounded-md transition-all duration-500 whitespace-nowrap cursor-pointer ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50/20 text-background-50 hover:bg-background-50/30 backdrop-blur-sm"
            }`}
          >
            Enrol Now
          </a>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-500 ${
              useLightText ? "text-background-50" : "text-foreground-800"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/50">
          <nav className="flex flex-col px-4 py-6 gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-base font-body font-medium transition-colors duration-300 ${
                  location.pathname === link.href
                    ? "text-foreground-950"
                    : "text-foreground-600"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://sraimes43.systeme.io/course"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-block bg-primary-500 text-background-50 font-body text-sm font-medium px-5 py-2.5 rounded-md text-center transition-colors duration-300 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              Enrol Now
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}